import { DefaultUrlSerializer, UrlTree } from "@angular/router";

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  _Parse(url: string): UrlTree {
    return super.parse(url.toLowerCase());
  }
}
